import React, { useEffect } from 'react';
import DashboardPage from '../../src/features/Dashboard/containers/Dashboard';
import { canUseDOM } from '../../src/utils';
import pagesMeta from '../../src/constants/pages-meta';
import { withAuth } from '../../src/utils/auth-client';

function ReferAFriend() {
  useEffect(() => {
    if (canUseDOM) {
      window.friendbuy = window.friendbuy || [];
      window.friendbuy.push(['widget', 'dWA-oIG']);
    }
  }, []);

  return (
    <DashboardPage title={pagesMeta.referFriend.title} description={pagesMeta.referFriend.description}>
      <div className="friendbuy-dWA-oIG"></div>
    </DashboardPage>
  );
}

export default withAuth(
  ReferAFriend,
  () => '/dashboard/refer-a-friend',
  undefined,
  undefined,
  user => !user.can_refer && '/dashboard',
);
